import { render } from "./LazyImage.vue?vue&type=template&id=28c7e08a"
import script from "./LazyImage.vue?vue&type=script&lang=js"
export * from "./LazyImage.vue?vue&type=script&lang=js"

import "./LazyImage.vue?vue&type=style&index=0&id=28c7e08a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__